import {
  Card,
  CaptionedImage,
  ClassicCard,
  ControlCard,
  ImageOnly,
} from "../index.js";
import {
  dateFromUnixTimestamp as l,
  rehydrateDateAfterJsonization as w,
} from "../../util/date-utils.js";
import r from "../../../shared-lib/braze-shared-lib.js";
export function newCard(e, n, t, o, i, l, u, d, a, s, w, f, m, C, p, c, x, F) {
  let b;
  if (n === Card.es.ct || n === Card.es.St)
    b = new ClassicCard(e, t, o, i, l, u, d, a, s, w, f, m, C, p, c, x);
  else if (n === Card.es.tt)
    b = new CaptionedImage(e, t, o, i, l, u, d, a, s, w, f, m, C, p, c, x);
  else if (n === Card.es.rs)
    b = new ImageOnly(e, t, i, u, d, a, s, w, f, m, C, p, c, x);
  else {
    if (n !== Card.es.At)
      return r.j.error("Ignoring card with unknown type " + n), null;
    b = new ControlCard(e, t, d, s, C, p);
  }
  return F && (b.test = F), b;
}
export function newCardFromContentCardsJson(e) {
  if (e[Card.Tt.It]) return null;
  const n = e[Card.Tt.ns],
    r = e[Card.Tt.ts],
    t = e[Card.Tt.ls],
    o = e[Card.Tt.st],
    i = e[Card.Tt.os],
    u = e[Card.Tt.it],
    d = l(e[Card.Tt.us]),
    a = d;
  let s;
  s = e[Card.Tt.ds] === Card.Nt ? null : l(e[Card.Tt.ds]);
  return newCard(
    n,
    r,
    t,
    o,
    i,
    u,
    a,
    d,
    null,
    s,
    e[Card.Tt.URL],
    e[Card.Tt.ps],
    e[Card.Tt.fs],
    e[Card.Tt.xs],
    e[Card.Tt.gs],
    e[Card.Tt.js],
    e[Card.Tt.ys],
    e[Card.Tt.zs] || !1,
  );
}
export function newCardFromFeedJson(e) {
  return newCard(
    e.id,
    e.type,
    e.viewed,
    e.title,
    e.image,
    e.description,
    l(e.created),
    l(e.updated),
    e.categories,
    l(e.expires_at),
    e.url,
    e.domain,
    e.aspect_ratio,
    e.extras,
    !1,
    !1,
  );
}
export function newCardFromSerializedValue(e) {
  return (
    newCard(
      e[Card.hs.ns],
      e[Card.hs.ts],
      e[Card.hs.ls],
      e[Card.hs.st],
      e[Card.hs.os],
      e[Card.hs.it],
      w(e[Card.hs.cs]),
      w(e[Card.hs.us]),
      e[Card.hs.bs],
      w(e[Card.hs.ds]),
      e[Card.hs.URL],
      e[Card.hs.ps],
      e[Card.hs.fs],
      e[Card.hs.xs],
      e[Card.hs.gs],
      e[Card.hs.js],
      e[Card.hs.ys],
      e[Card.hs.zs] || !1,
    ) || void 0
  );
}
